import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row } from "reactstrap";
import { 
  fetchSettingsRequest, 
  updateSettingsRequest, 
  fetchDataRequest 
} from "../../store/actions";

import CommissionSettings from "./CommissionSettings";
import AboutUsSettings from "./AboutUsSettings";
import CompanyRegistrationSettings from "./CompanyRegistrationSettings";
import Bordcast from "./Bordcast";
import Admins from "./Admins";
import BannerUpload from "./BannerUpload";
import NewSuperAdminForm from "./NewSuperAdminForm";
import MaintenanceMode from "./MaintenanceMode";

const GeneralSettings = () => {
  const data = useSelector(state => state.settings);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSettingsRequest());
    dispatch(fetchDataRequest());
  }, [dispatch]);

  const handleSaveSettings = () => {
    if (data) {
      dispatch(updateSettingsRequest(data));
    }
  };

  return (
    <div className="page-content">
      <Container fluid={false}>
          <Row>
          <MaintenanceMode data={data} />
        </Row>
        <Row>
          <CommissionSettings commission={data} />
        </Row>
        <Row>
          <CompanyRegistrationSettings data={data} />
        </Row>
        <Row>
          <AboutUsSettings about={data} />
        </Row>
        <Row>
          {/* <Bordcast /> */}
        </Row>
        <Row>
          <NewSuperAdminForm />
          <Admins />
        </Row>

        <BannerUpload />
      </Container>
    </div>
  );
};

export default GeneralSettings;
